import { sql, type SQL } from 'drizzle-orm';
import { SQLiteSyncDialect, type SQLiteColumn } from 'drizzle-orm/sqlite-core';
import { monthKeySqlText } from '@/lib/monthCycle';

const dialect = new SQLiteSyncDialect();

/**
 * Chave do período (`yyyy-MM`, ADR 0190) de uma coluna de data, em SQL — o substituto de
 * `substr(date, 1, 7)` nas consultas que agrupam ou filtram por mês. Com Dia de início 1
 * vira exatamente o `substr` de antes. A expressão é a mesma de `monthKeySqlText` (uma fonte
 * só); a coluna é renderizada pelo dialeto pra não depender de nome de tabela digitado.
 */
export function monthKeySql(column: SQLiteColumn | SQL, startDay: number): SQL<string> {
    const rendered = dialect.sqlToQuery(sql`${column}`).sql;
    return sql.raw(monthKeySqlText(rendered, startDay)) as SQL<string>;
}
